//スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

//フェードイン
$(function(){
    $(window).scroll(function (){
        $('.fadein').each(function(){
            var elemPos = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > elemPos - windowHeight + 100){
                $(this).addClass('scrollin');
            }
        });
    });
});
$(function(){
    $(window).scroll(function (){
        $('.fadein2').each(function(){
            var elemPos = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > elemPos - windowHeight + 100){
                $(this).addClass('scrollin');
            }
        });
    });
});
$(function(){
    $(window).scroll(function (){
        $('.fadein3').each(function(){
            var elemPos = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > elemPos - windowHeight + 100){
                $(this).addClass('scrollin');
            }
        });
    });
});
$(function(){
    $(window).scroll(function (){
        $('.fadein4').each(function(){
            var elemPos = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > elemPos - windowHeight + 100){
                $(this).addClass('scrollin');
            }
        });
    });
});

//横文字を流す
$(window).on('scroll', function(){

  var scrollTop = $(window).scrollTop();
  var bgPosition = scrollTop / 1;

  if(bgPosition){
    $('#txtscroll').css('background-position', 'left top -'+ bgPosition + 'px').css('top', '0');
  }
});

jQuery(function($){
  var $window = $(window);
 
  $('#gallery_04').each(function(index) {
    var $self = $(this);
    var offsetPositions = $self.offset();
 
    $(window).scroll(function() {
      // この領域がブラウザに表示されている場合
      if (($window.scrollTop() + $window.height()) > offsetPositions.top && ((offsetPositions.top + $self.height()) > $window.scrollTop())) {
        var offsetY =  -(($window.scrollTop() - offsetPositions.top)/ 17); 
        //var offsetY =  -($window.scrollTop()/ 17); 
        var positions = '50%' + offsetY + 'px';
        $self.css('backgroundPosition', positions);
      }
    });
  });
});

//画像アニメーション
$(function(){
    $('.animation_area').css("opacity","0");
    $(window).scroll(function (){
        $(".animation_area").each(function(){
            var imgPos = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > imgPos - windowHeight + windowHeight/5){
                $(this).css("opacity","1");
                $(this).find('.key_2').addClass('dummy_area');
                $(this).find('.key_1').addClass('img_area');
            }
        });
    });
});

//カーソル変更
if(!navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)){
    $(function(){
        var body = document.body;
        var cursor = document.createElement("div");
        var stalker = document.createElement("div");
        cursor.id = "cursor";
        stalker.id = "stalker";
        body.appendChild(cursor);
        body.appendChild(stalker);
        body.addEventListener("mousemove", function(e) {
              cursor.style.left = e.clientX + "px";
              cursor.style.top = e.clientY + "px";
              stalker.style.left = e.clientX + "px";
              stalker.style.top = e.clientY + "px";
        }, false);
 
        $("a").on("mouseenter", function() {
            $('#cursor').addClass("active");
            $('#stalker').addClass("active");
        });
 
        $("a").on("mouseleave", function() {
            $('#cursor').removeClass("active");
            $('#stalker').removeClass("active");
        });
    });
}

$(function () {
    if ($('.border').length) {
        scrollAnimation();
    }
    function scrollAnimation() {
        $(window).scroll(function () {
            $(".border").each(function () {
                let position = $(this).offset().top,
                    scroll = $(window).scrollTop(),
                    windowHeight = $(window).height();

                if (scroll > position - windowHeight + 50) {
                    $(this).addClass('is-animation');
                }
            });
        });
    }
    $(window).trigger('scroll');
});